// 移植自 crm/src/pages/RouteFallback.jsx。萬用路由(*)落點：網址列直打／整頁重載進到未知路徑時，
// 靜默導回最後一次成功匹配的頁面（AppLayout 負責記錄），沒有可回的頁就回 /home。
// 站內導航的未知路徑由 AppLayout 的 useBlocker 先擋下，不會走到這裡。
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'

export const LAST_VALID_PATH_KEY = 'crm:last-valid-path'

export function RouteFallback() {
  const navigate = useNavigate()
  const done = useRef(false)
  useEffect(() => {
    // StrictMode 開發模式會跑兩次 effect，第二次記錄已被清掉會誤導回 /home
    if (done.current) return
    done.current = true
    const last = sessionStorage.getItem(LAST_VALID_PATH_KEY)
    // 先清掉再導：記錄的路徑若已失效，第二次進來改走 /home，不會無窮迴圈
    sessionStorage.removeItem(LAST_VALID_PATH_KEY)
    navigate(last || '/home', { replace: true })
  }, [navigate])
  return null
}
